export const DEFAULT_AVATAR_SRC = 'https://zora.co/default-avatar.png'
